  // create array of featured courses for later use in featured course widget
/*
  var featured_courses = [];
  $('.featuredCoursesProduct').each(function(index) {
    var product = {};
    product['featured_image'] = $(this).attr('data-product-featured-image');
    product['url'] = $(this).attr('data-product-url');
    product['course_code'] = $(this).attr('data-product-course-code');
    product['course_title'] = $(this).attr('data-product-course-title');
    product['course_type'] = $(this).attr('data-product-course-type');
    product['grade'] = $(this).attr('data-product-grade');
    product['overview'] = $(this).attr('data-product-overview');
  	featured_courses.push(product);
  });
  console.log(featured_courses);
*/
  
  /* parse featured_courses array and add divs to the slider */
/*
featured_courses.forEach(function(product){
    $(".featured").append("<div class='featured-product-box'>abc</div>"); 
});
*/

// adding product title as alt for all images in a loop
$(".featured-product-box").each(function(index) {
    product_title = $(this).find('.featured-product-title').text();
    $(this).find('img').attr('alt', product_title);
});

$(".featured").slick({
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
    ]
});

$(".slick-prev").html("");
$(".slick-next").html("");  